// extracted by mini-css-extract-plugin
module.exports = {"root":"AdditionalInfo_root__2_hDz","collapsed":"AdditionalInfo_collapsed__2jlE0"};